<template>
  <v-container
    fluid
  >
    <br>
    <h1 class="title-style">
      <v-icon class="icon-style">
        mdi-apps
      </v-icon> App Modules
    </h1>
    <v-card
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          class="text-right"
          @click="showCreateForm = true"
        >
          Create New
        </v-btn>
      </v-col>
      <br>
      <v-row>
        <v-col
          v-for="(item, index) in appModules"
          :key=" index"
          class="py-0 mt-2"
          cols="12"
        >
          <v-row
            class="fill-height flex-column text-h6 row-style"
          >
            <v-card class="card-style">
              <p class="my-p-style">
                {{ item.name | displayFormat }}
              </p>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <br>
      <br>
      <p
        v-if="!isAppModuleExists"
        class="my-alert-style"
      >
        No App Modules Found.
      </p>
    </v-card>
    <create-app-module
      v-if="showCreateForm"
      @closed="showCreateForm = false"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import CreateAppModule from 'src/views/dashboard/appmodules/CreateAppModule.vue';

  export default {
    name: 'AppModules',
    components: {
      'centre-spinner': spinner,
      'create-app-module': CreateAppModule,
    },
    filters: {
      displayFormat (name) {
        if (name === 'digital-signage') {
          return 'Digital Signage';
        } else if (name === 'swift-check-in') {
          return 'Swift Check-In';
        } else if (name === 'swift-check-in-projects') {
          return 'Swift Check-In Projects';
        }
      },
    },
    data () {
      return {
        loading: false,
        showCreateForm: false,
      };
    },
    computed: {
      appModules () {
        return this.$store.getters['organizations/getAppModules'];
      },
      isAppModuleExists () {
        return this.appModules.length > 0;
      },
    },
    async mounted () {
      await this.fetchAppModules();
    },
    methods: {
      async fetchAppModules () {
        this.loading = true;
        await this.$store.dispatch('organizations/fetchAppModules');
        this.loading = false;
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 40px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.my-p-style {
  font-size: 20px;
  font-weight: bold;
  color: #37474F;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  align-content: center !important;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
.my-alert-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
.row-style {
  margin-left: 10px;
  margin-right: 10px;
}
.card-style {
  margin-top: 15px;
  margin-right: 20px;
  margin-left: 20px;
}
</style>
